import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { printApiError, validate } from '@utils/Util';

const ForgetPassword = () => {
	const [email, setEmail] = useState('');
	const [emailError, setEmailError] = useState('');
	const [loading, setLoading] = useState(false);
	const [showForm, setShowForm] = useState(true);

	const send = () => {
		if (!emailError) {
			if (email) {
				const body = { email };
				setLoading(true);
				ApiClient.POST('forgetPassword', body)
					.then(({ data }) => {
						setLoading(false);
						if (data.success) {
							toastSuccess(data.message);
							setShowForm(false);
						} else {
							toastError(data.message);
						}
					})
					.catch((error) => {
						setLoading(false);
						printApiError(error);
					});
			} else {
				setEmailError('Email is required!');
			}
		}
	};

	const onChange = (e) => {
		const { name, value } = e.target;
		let err = validate(e);
		if (name === 'email') {
			setEmail(value);
			setEmailError(err.value);
		}
	};

	if (showForm) {
		return (
			<LoaderComponent loading={loading}>
				<section className="">
					<div className="container auth-page">
						<div className="row fullscreen justify-content-center align-items-center">
							<div className="col-md-8">
								<div className="section-header text-center">
									<h3 className="section-title">Forgot your password?</h3>
									<p className="section-subtitle">
										Enter your registered email below to receive password reset
										instructions.
									</p>
								</div>
								<form className="registration-form mt-5 forgot-pass">
									<div className="form-group m-0">
										<label>Email Address</label>
										<div className="input-group">
											<input
												type="email"
												autoComplete="off"
												className="form-control"
												placeholder="jondoe@nitexid.com"
												name="email"
												value={email}
												onChange={onChange}
											/>
											<div className="input-group-append lock">
												<span>
													<img
														src={`${process.env.PUBLIC_URL}/images/icons/envelope.png`}
														alt="email"
														className="img-fluid"
													/>
												</span>
											</div>
										</div>
										{emailError && <span className="error">{emailError}</span>}
									</div>
									<button type="button" className="button size40 w-100 my-4" onClick={send}>
										Send
									</button>
									<div className="text-center">
										<Link
											to="/login"
											className="text-active"
											style={{ color: 'initial' }}
										>
											Back to Login
										</Link>
									</div>
								</form>
							</div>
						</div>
					</div>
				</section>
			</LoaderComponent>
		);
	} else {
		return (
			<section className="">
				<div className="container auth-page">
					<div className="row fullscreen justify-content-center align-items-center">
						<div className="col-8">
							<div className="section-header text-center">
								<div className="chek-email mb-5">
									<img src={`${process.env.PUBLIC_URL}/images/check-email.png`} alt="" />
								</div>
								<h4 className="section-title">Check your email</h4>
								<p className="section-subtitle">
									We have sent a password recovery instruction to your email.
								</p>
							</div>
							<a
								type="button"
								href="https://mail.google.com/"
								className="btn btn-nitex-default btn-block my-4"
								style={{ color: 'white' }}
							>
								Go to email address
							</a>
						</div>
					</div>
				</div>
			</section>
		);
	}
};

export default ForgetPassword;
